import styled from 'styled-components';

export const ChatButtonContainer = styled.div`
  position: fixed;
  z-index: 1000;
  background: linear-gradient(to bottom, ${(props) => props.$chatThemeColorIn}, ${(props) => props.$chatThemeColor});
  width: 54px;
  height: 54px;
  border-radius: 50%;
  border: transparent;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
`;
